<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12" class="icon">
	<defs></defs>
	<g transform="translate(-23 -15)">
		<rect class="icon__path" width="17" height="2" rx="1" transform="translate(23 25)" />
		<rect class="icon__path" width="10" height="2" rx="1" transform="translate(23 15)" />
		<rect class="icon__path" width="17" height="2" rx="1" transform="translate(23 20)" />
	</g>
</svg>
